import api from "./api";
import endpoints from "./endpoints";

export default {
  getMediaAssetSubfolders(path) {
    return api.get(endpoints.mediaAssets.subFolders, { params: { path } }).then((x) => Promise.resolve(x.data));
  },
  getMediaAssetFilesFromFolder(path) {
    return api.get(endpoints.mediaAssets.files, { params: { path } }).then((x) => Promise.resolve(x.data));
  },
  validateFilePath: async function (path) {
    const response = await api.get(endpoints.mediaAssets.validateFilePath, {
      params: { path }
    });
    return response.data;
  },
  executeSearch: async function (searchId, relativePath, searchTerm) {
    const response = await api.post(
      endpoints.mediaAssets.executeSearch,
      {},
      {
        params: { searchId, relativePath, searchTerm }
      }
    );
    return response.data;
  },
  cancelSearch: async function (searchId) {
    const response = await api.post(
      endpoints.mediaAssets.cancelSearch,
      {},
      {
        params: { searchId }
      }
    );
    return response;
  },
  deleteMediaAsset: async function (formdata) {
    return api.post(endpoints.mediaAssets.deleteMediaAsset, formdata, {});
  },
  deleteMediaAssetFolder: async function (formdata) {
    return api.post(endpoints.mediaAssets.deleteMediaAssetFolder, formdata, {});
  },
  renameMediaAsset: async function (path, name) {
    return api.post(endpoints.mediaAssets.renameMediaAsset, {}, { params: { path, name } });
  },
  renameMediaAssetFolder: async function (path, name) {
    return api.post(endpoints.mediaAssets.renameMediaAssetFolder, {}, { params: { path, name } });
  },
  uploadMediaAsset(path, overwrite, formdata) {
    return api
      .post(endpoints.mediaAssets.uploadMediaAsset, formdata, {
        params: { path, overwrite },
        headers: { "Content-Type": "multipart/form-data" }
      })
      .then((x) => Promise.resolve(x.data));
  },
  startMediaConversion(articleId, mediaAssetIds, languageCode, connectionId) {
    api.post(endpoints.mediaAssets.startMediaConversion, mediaAssetIds, {
      params: { articleId, languageCode, connectionId }
    });
  },
  startAllMediaConversion: function (articleId, languageCode, connectionId) {
    api.post(
      endpoints.mediaAssets.startAllMediaConversion,
      {},
      {
        params: { articleId, languageCode, connectionId }
      }
    );
  },
  copySourceFileIntoTargetPath: async function (sourceFilePath, targetPath) {
    const response = await api.get(endpoints.mediaAssets.copySourceFileIntoTargetPath, { params: { sourceFilePath, targetPath, overwrite: true } });
    return response.data;
  },
  get(languages, targetType) {
    return api
      .get(endpoints.attributeManager.mediaAssets.get, {
        params: { languages, targetType }
      })
      .then((x) => Promise.resolve(x.data));
  },
  update(model, targetType) {
    return api
      .post(endpoints.attributeManager.mediaAssets.update, model, {
        params: { targetType }
      })
      .then((x) => Promise.resolve(x.data));
  },
  delete(items) {
    return api.post(endpoints.attributeManager.mediaAssets.delete, items).then((x) => Promise.resolve(x.data));
  },
  getPreviewMediaAsset(targetType) {
    return api
      .get(endpoints.attributeManager.mediaAssets.getPreviewMediaAsset, {
        params: { targetType }
      })
      .then((x) => Promise.resolve(x.data));
  },
  setPreviewMediaAsset(mediaAssetId, targetType) {
    return api
      .post(endpoints.attributeManager.mediaAssets.setPreviewMediaAsset, {}, { params: { mediaAssetId, targetType } })
      .then((x) => Promise.resolve(x.data));
  },
  getConversionProfiles() {
    return api.get(endpoints.attributeManager.mediaAssets.getConversionProfiles).then((x) => Promise.resolve(x.data));
  },
  getMamDetails() {
    return api.get(endpoints.attributeManager.mediaAssets.getMamDetails).then((x) => Promise.resolve(x.data));
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api.post(endpoints.attributeManager.mediaAssets.deepL, model, { params: { sourceLanguage: sourceLanguage } }).then((x) => Promise.resolve(x.data));
  },
  getDetails: async function (language, attributeIds) {
    const response = await api.post(endpoints.attributeManager.mediaAssets.details, attributeIds, {
      params: { language }
    });
    return response.data;
  },
  createMediaAssetFolder: async function (path, name) {
    const response = await api.post(
      endpoints.mediaAssets.folder.create,
      {},
      {
        params: { path, name }
      }
    );
    return response.data;
  }
};
